import React from "react";

export const Navigation = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src="/img/drapeau.svg" alt="Drapeau" height="60" />
            <img src="/img/logo2.svg" alt="L'Atelier des pilotes" height="60" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse bg-primary"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#permis" className="page-scroll">
                Permis
              </a>
            </li>
            <li>
              <a href="#apropos" className="page-scroll">
                A Propos
              </a>
            </li>
            <li>
              <a href="#avis" className="page-scroll">
                Avis
              </a>
            </li>
            <li>
              <a href="#label" className="page-scroll">
                Label
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
